export default "__VITE_ASSET__$wJWcuRY__"